/** 旧版 guide 数据（供 localeContent 兼容），图片路径与 guideAssets 一致 */
export default {
  bcfw: {
    intro: [
      { title: "", desc: "", post: require("../assets/guide/bcfw/description1.jpg") },
      { title: "", desc: "", post: require("../assets/guide/bcfw/description2.jpg") },
    ],
    swiper: [],
  },
  cjly: {
    intro: [
      { title: "", desc: "", post: require("../assets/guide/jdyd/description1.jpg") },
      { title: "", desc: "", post: require("../assets/guide/jdyd/description2.jpg") },
    ],
    swiper: [
      { title: "", post: require("../assets/guide/jdyd/description3.jpg") },
      { title: "", post: require("../assets/guide/jdyd/description4.jpg") },
    ],
  },
  gnly: {
    intro: [
      { title: "", desc: "", post: require("../assets/guide/mpyd/description1.jpg") },
      { title: "", desc: "", post: require("../assets/guide/mpyd/description2.jpg") },
    ],
    swiper: [
      { title: "", post: require("../assets/guide/mpyd/description3.jpg") },
      { title: "", post: require("../assets/guide/mpyd/description4.jpg") },
    ],
  },
  qydz: {
    intro: [
      { title: "", desc: "", post: require("../assets/guide/zgwd/description1.jpg") },
      { title: "", desc: "", post: require("../assets/guide/zgwd/description2.jpg") },
    ],
    swiper: [],
  },
  qzbl: {
    intro: [
      { title: "", desc: "", post: require("../assets/guide/qzbl/description1.jpg") },
      { title: "", desc: "", post: require("../assets/guide/qzbl/description2.jpg") },
    ],
    swiper: [],
  },
  srdz: {
    intro: [
      { title: "", desc: "", post: require("../assets/guide/ztly/description1.jpg") },
      { title: "", desc: "", post: require("../assets/guide/ztly/description2.jpg") },
    ],
    swiper: [],
  },
};
